import { useState } from 'react';
import Form from './components/Form/Form';
import RecommendationList from './components/RecommendationList/RecommendationList';

function App() {
  const [recommendations, setRecommendations] = useState([]);

  //  Função que atualiza as recomendações quando o formulário é submetido
  const handleRecommendationsUpdate = (newRecommendations) => {
    setRecommendations(newRecommendations);
  };

  return (
    <div className="bg-gradient-to-br from-rd-navy via-rd-navy to-blue-900 min-h-screen py-12 px-4">
      {/* Header */}
      <div className="max-w-6xl mx-auto mb-8 md:mb-12 text-center px-2">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4">
          Recomendador de Produtos
          <span className="text-rd-blue"> RD Station</span>
        </h1>
        <p className="text-rd-cyan text-base md:text-lg max-w-3xl mx-auto px-4">
          Encontre a solução perfeita para o seu negócio. Selecione suas
          preferências e receba recomendações personalizadas.
        </p>
      </div>

      {/* Main Container */}
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Info Banner */}
          <div className="bg-gradient-to-r from-rd-blue to-rd-cyan p-4 md:p-6">
            <p className="text-rd-navy font-medium text-center text-sm md:text-base">
              💡 De CRM a Marketing, de Conversas a Inteligência Artificial -
              temos a solução ideal para impulsionar seus resultados
            </p>
          </div>

          {/* Content */}
          <div className="p-4 md:p-8 space-y-6 md:space-y-8">
            {/* Form Section */}
            <Form onRecommendationsUpdate={handleRecommendationsUpdate} />

            {/* Recommendations Section - Full width below */}
            <RecommendationList recommendations={recommendations} />
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-rd-cyan text-sm">
          <p>
            © 2025 RD Station - Teste Técnico - Desenvolvido por{' '}
            <a 
              href="https://github.com/geanemr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-bold hover:text-rd-blue transition-colors duration-200 underline"
            >
              Geane
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
